import http from 'core/http.service';
import BaseService from 'services/BaseService';
import { InboundKpiDTO, ReceptionKpiDTO, TripKpiDTO, RepairKpiDTO, RepairStatisticsKpiDTO } from 'models/kpi';
import { ReceptionSearchDTO } from 'models/reception';

class KpiService extends BaseService {

    /**
     * 출장관리 KPI 데이터 조회
     * @param {string} ym - 대상 월 (YYYY-MM 형식)
     * @returns {Promise<Object>} KPI 데이터
     */
    public trip(ym: string): Promise<TripKpiDTO> {
        return super.request(http.get('/kpi/trip', { ym }));
    }

    /**
     * 접수관리 KPI 데이터 조회
     * @returns {Promise<Object>} KPI 데이터
     */
    public reception(): Promise<ReceptionKpiDTO> {
        return super.request(http.get('/kpi/reception'));
    }

    /** 
     * 입고관리 KPI 조회
     */
    public inbound(): Promise<InboundKpiDTO> {
        return super.request(http.get('/kpi/inbound'));
    }

    /** 
     * 수리관리 KPI 조회
     */
    public repair(): Promise<RepairKpiDTO> {
        return super.request(http.get('/kpi/repair'));
    }

    /**
     * 수리실적 KPI 조회
     * @param {ReceptionSearchDTO} search - 검색 조건
     * @returns {Promise<RepairStatisticsKpiDTO>} 수리실적 KPI 데이터
     */
    public repairStatistics(search: ReceptionSearchDTO): Promise<RepairStatisticsKpiDTO> {
        return super.request(http.get('/kpi/repair-statistics', search));
    }
}

const kpiService = new KpiService();
export default kpiService;